{
  "name": "energy_master_frontend",
  "version": "0.0.1",
  "author": "EnergyMaster",
  "homepage": "https://em-frontend.wunu.dev/",
  "scripts": {
    "ng": "ng",
    "start": "ionic serve",
    "start:ddev": "ionic serve -c local --host 0.0.0.0 --port 8100 --no-open",
    "build": "ng build",
    "build:local": "ng build --configuration local",
    "build:dev": "ng build --configuration development",
    "build:stage": "ng build --configuration stage",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --watch=false",
    "test:watch": "ng test",
    "lint": "ng lint",
    "cy:open": "cypress open",
    "cy:run": "cypress run",
    "e2e": "start-server-and-test serve-local http://localhost:8100 cy:run",
    "serve-prod": "ionic serve -c production --no-open",
    "serve-stage": "ionic serve -c stage --no-open",
    "serve-dev": "ionic serve -c development --no-open",
    "serve-local": "ionic serve -c local --no-open",
    "sync-dev": "ionic cap sync -c development"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^22.1.5",
    "@angular/common": "^22.1.5",
    "@angular/compiler": "^22.1.5",
    "@angular/core": "^22.1.5",
    "@angular/forms": "^22.1.5",
    "@angular/platform-browser": "^22.1.5",
    "@angular/router": "^22.1.5",
    "@capacitor/app": "^8.1.1",
    "@capacitor/core": "^8.4.2",
    "@capacitor/device": "^8.0.2",
    "@capacitor/haptics": "^8.0.2",
    "@capacitor/keyboard": "^8.0.5",
    "@capacitor/status-bar": "^8.0.3",
    "@fortawesome/angular-fontawesome": "^5.1.0",
    "@fortawesome/fontawesome-svg-core": "^7.2.0",
    "@fortawesome/free-brands-svg-icons": "^7.2.0",
    "@fortawesome/sharp-light-svg-icons": "^7.2.0",
    "@fortawesome/sharp-regular-svg-icons": "^7.2.0",
    "@fortawesome/sharp-solid-svg-icons": "^7.2.0",
    "@fortawesome/sharp-thin-svg-icons": "^7.2.0",
    "@ionic/angular": "^9.0.0",
    "@ionic/storage-angular": "^4.0.0",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@sentry/angular": "10.69.0",
    "@sentry/capacitor": "4.4.0",
    "angularx-qrcode": "^22.0.1",
    "echarts": "^6.1.0",
    "html2canvas-pro": "^2.4.5",
    "ionicons": "^8.0.13",
    "jspdf": "^4.2.1",
    "laravel-echo": "^2.3.3",
    "mapbox-gl": "^3.30.0",
    "ngx-echarts": "^22.0.0",
    "postcss": "^8.5.15",
    "pusher-js": "^8.5.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.2.0",
    "@angular-eslint/eslint-plugin": "^22.2.0",
    "@angular-eslint/eslint-plugin-template": "^22.2.0",
    "@angular-eslint/schematics": "^22.2.0",
    "@angular-eslint/template-parser": "^22.2.0",
    "@angular/build": "^22.1.7",
    "@angular/cli": "^22.1.7",
    "@angular/compiler-cli": "^22.1.5",
    "@angular/language-service": "^22.1.5",
    "@capacitor/cli": "^8.4.2",
    "@ionic/angular-toolkit": "^13.0.0",
    "@ionic/cli": "^7.2.1",
    "@tailwindcss/postcss": "^4.3.1",
    "@typescript-eslint/eslint-plugin": "^8.18.0",
    "@typescript-eslint/parser": "^8.18.0",
    "angular-eslint": "^22.5.0",
    "cypress": "^15.17.0",
    "eslint": "^9.16.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-jsdoc": "^48.2.1",
    "eslint-plugin-prefer-arrow": "^1.2.2",
    "jsdom": "^29.1.1",
    "postcss": "^8.5.3",
    "start-server-and-test": "^3.0.11",
    "tailwindcss": "^4.3.1",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.18.0",
    "vitest": "^4.1.11"
  },
  "description": "EnergyMaster Ionic Angular frontend"
}
